module.exports = __webpack_public_path__ + "static/assets/12a885cafad98b8fecd6d02e0499ad1e.png";